import { useEffect, useRef, useState } from "react";
import { Button } from "../ui/primitives";

const CONFIRM_MS = 1500;

/**
 * Says "✓ Added!" for a moment after a click, so a buyer can see the click landed without
 * leaving the page. It stays clickable meanwhile: a second click is a second one in the cart.
 */
export function AddToCartButton({
  onAdd,
  className,
  size,
  variant,
}: {
  onAdd: () => void;
  className?: string;
  size?: "sm" | "md";
  variant?: "primary" | "subtle";
}) {
  const [added, setAdded] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(
    () => () => {
      if (timer.current) clearTimeout(timer.current);
    },
    [],
  );
  return (
    <Button
      size={size}
      variant={variant}
      className={className}
      aria-live="polite"
      onClick={() => {
        onAdd();
        setAdded(true);
        if (timer.current) clearTimeout(timer.current);
        timer.current = setTimeout(() => setAdded(false), CONFIRM_MS);
      }}
    >
      {added ? "✓ Added!" : "Add to cart"}
    </Button>
  );
}
